import React from "react";

const field =
  "block w-full rounded-lg border border-border bg-background px-3 py-2 " +
  "text-foreground placeholder-muted-foreground focus:outline-none " +
  "focus:ring-2 focus:ring-brand/40 focus:border-brand/50";

export function ABTestForm({ formData, setFormData }) {
  return (
    <section className="space-y-4">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
        A/B Test
      </h3>
      <label className="space-y-1">
        <span className="text-sm font-medium">Hypothesis *</span>
        <textarea
          required
          rows={3}
          value={formData.expectedOutcome}
          onChange={(e) =>
            setFormData((prev) => ({
              ...prev,
              expectedOutcome: e.target.value,
            }))
          }
          className={`${field} min-h-[96px]`}
          placeholder="State your test hypothesis"
        />
      </label>
    </section>
  );
}
